<template>
  <div class="public-form">
    <div class="public-form-bg"></div>
    <div class="public-form--support">
      <div class="support-logo">
        <img src="../../../assets/logo-light.png" alt="logo">
      </div>
      <span class="support-text">提供技术支持</span>
    </div>
    <div ref="publicFormBodyDom" class="public-form-body" @scroll="handleScroll">
      <div class="public-form-container" :class="{'public-form-readonly': shareConfig.operationAuth === 'READ'}">
        <div class="public-form-body--header">
          <div class="header-info">
            <h4 class="header-info-title">
              {{ publicConfig.shareName }}
            </h4>
            <span class="header-info-desc">{{ publicConfig.shareDesc }}</span>
          </div>
          <div v-if="shareLogo" class="header-logo">
            <img :src="shareLogo" alt="logo">
          </div>
        </div>
        <div class="public-form-body--content">
          <router-view></router-view>
        </div>
      </div>
      <div class="public-form-footer">
        <span class="public-form--origin">由{{ publicConfig.tenantName }}·{{ publicConfig.username }}分享的表单</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ScrollBehaviorMixin from '@/mixin/scroll-behavior.mixin'
import { SET_CURRENT_DEPARTMENT } from '@/store/tenant.store.js'

export default {
  name: 'PublicForm',
  mixins: [ScrollBehaviorMixin],
  data() {
    return {
      shareLogo: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.authModule.token,
      currentOrg: state => state.tenantModule.currentOrg,
      publicConfig: state => state.publicFormModule.publicConfig,
      shareConfig: state => state.publicFormModule.shareConfig
    })
  },
  watch: {
    publicConfig: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.setDepartment(newVal.userDepartment)
          if (!newVal.isExpire && newVal.logoUrl) {
            this.shareLogo = this.showImg({
              url: newVal.logoUrl
            })
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('tenantModule', {
      setDepartment: SET_CURRENT_DEPARTMENT
    }),
    showImg(...args) {
      let data = args[args.length - 1]
      const params = this.$base64.encode(JSON.stringify({
        xdaptenantid: this.$route.query.tenantId,
        xdaptoken: this.publicConfig.shareToken || this.token
      }))
      console.log(params)
      return `${data.url}&token=${params}`
    },
    scrollToY(y) {
      this.$refs.publicFormBodyDom.scrollTop = y
    }
  }
}
</script>

<style lang="scss">
.public-form {
  position: relative;
  width: 100%;
  min-height: 100%;
  background-color: $--app-body-bgColor;
  .public-form-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 11.43rem;
    background-color: $--app-primary-color;
  }
  .public-form--support {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    line-height: .5rem;
    color: $--app-white-font-color;
    .support-logo {
      position: relative;
      top: -1px;
      width: 3.9rem;
      height: 1rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .support-text {
      margin-left: 0.5rem;
      font-weight: $--app-base-font-weight;
    }
  }
  .public-form-body {
    position: absolute;
    top: 3.43rem;
    width: 100%;
    height: calc(100% - 3.43rem);
    overflow-y: auto;
    .public-form-container {
      border-radius: 0.285rem;
      background-color: $--app-box-bgColor;
      overflow: hidden;
      &.public-form-readonly {
        margin: 0 1.14rem;
      }
    }
    .public-form-body--header {
      display: flex;
      align-items: center;
      height: 8rem;
      padding: 1.14rem;
      box-sizing: border-box;
      border-bottom: 1px solid $--app-split-line-color;
      .header-info {
        flex: 1;
        .header-info-title {
          font-weight: $--app-base-font-weight;
          margin-bottom: 0.57rem;
        }
        .header-info-desc {
          font-size: $--app-base-font-size;
          color: $--app-notice-font-color;
        }
      }
      .header-logo {
        flex: 0 0 10rem;
        width: 10rem;
        height: 5.71rem;
        margin-left: 1.14rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .public-form-footer {
      color: $--app-notice-font-color;
      text-align: center;
      margin: .5rem 0;
    }
  }
}
</style>
